<template>
    <mdb-container fluid>    
        <mdb-row v-if="layout_ready" class="justify-content-md-center bg-cover" :style="'background: #FFF url('+layoutData.BACKGROUNDIMG+') no-repeat; min-height:'+screen_height+ ';'">
            
           <div :style="'width:'+layoutData['box_width']" class="custom_login_outer" role="main">
            
                <mdb-card class="login-box" :style="'background:'+layoutData['background_color']">
                <mdb-card-body>
                    <p v-html="layoutData['COMPANYANNOUNCEMENTLABEL']"></p>
                   <!-- Material form login :style="'background: #FBFBFB url("'+layoutData['BACKGROUNDIMG']+'") no-repeat;'
                <form>-->
                <!--<p class="h4 text-center mb-4" v-html="layoutData['COMPANYTITLELABEL']"></p>-->
                <h2 class="text-center mb-4" style="font-size: 30px;" v-html="layoutData['COMPANYTITLELABEL']"></h2>
                <template v-if="(layoutData['DISABLE_NORMAL_LOGIN']==0 || layoutData['DISABLE_NORMAL_LOGIN']==undefined)">
                    <div class="grey-text">
                    <mdb-input v-if="(!layoutData['COMPANYUSERNAME'])" :label="layoutData['COMPANYUSERNAMELABEL']" icon="envelope" role="alert" ref="ccode" type="text" v-model="user" @keyup.enter.native="validateLogin" autocomplete="username"/>
                    
                    <mdb-input v-if="(layoutData['COMPANYUSERNAME'])"   type="hidden" v-model="user"/>
                    
                    <mdb-input v-if="(!layoutData['COMPANYPASSWORD'])" :label="layoutData['COMPANYPASSWORDLABEL']" icon="lock" role="alert" ref="psw" type="password" v-model="pass" @keyup.enter.native="validateLogin" autocomplete="current-password" />
                    <mdb-input v-if="(layoutData['COMPANYPASSWORD'])" type="hidden" v-model="pass"/>
                    <mdb-input v-if="(layoutData['COMPANYPASSWORD'])" type="hidden" value="1" v-model="encrypt_flag"/>
                    
                    </div>
                    <div class="text-center">
                        <mdb-btn v-on:click="validateLogin" class="btn-login">Login</mdb-btn>
                    </div>
                </template>
                <div v-if="(layoutData['ENABLE_SSO']==1 )">
                    <div class=" orsection" v-if="(layoutData['DISABLE_NORMAL_LOGIN']==0 || layoutData['DISABLE_NORMAL_LOGIN']==undefined)"><span class="orspan">OR</span></div>
                    <div class="text-center">
                        <mdb-btn v-if="(layoutData['IS_AZURE_SSO']==1 )" v-on:click="sso_url" class="btn btn-login btn-sso">{{sso_button}}</mdb-btn>
                        <mdb-btn v-if="(layoutData['IS_AUTHO_SSO']==1 )" id="loginAuthO" class="btn btn-login btn-sso">{{sso_button}}</mdb-btn>
                        <mdb-btn v-if="(layoutData['IS_WSO_SSO']==1 )" id="loginWSO" class="btn btn-login btn-sso">{{sso_button}}</mdb-btn>
                    </div>
                </div>
                <div class="text-center" role="alert">
                    <mdb-badge pill color="white" :v-if="err" >{{err}}</mdb-badge>
                </div>
               <!-- </form>
             Material form login -->
                <p v-html="layoutData['COMPANYANNOUNCEMENTLABELDOWN']"></p>
                </mdb-card-body>
                </mdb-card>            
           </div>           
            <mdb-col lg ="12" class="text-center-align" role="contentinfo">
                <p v-html="layoutData['LOGINFOOTER']"></p>
            </mdb-col>                  
        </mdb-row>
        <mdb-row v-else>
            <span role="alert" aria-live="assertive" class="sr-only">loading...</span>
            <img :src="LOCAL_HOST+'/ThemeMegazine/images/loader_dot.gif'" height="20" />
        </mdb-row>
  </mdb-container>
</template>

<script>
import axios from 'axios';
import { mdbRow, mdbContainer, mdbCol, mdbInput, mdbBtn,mdbCard, mdbCardBody,mdbBadge  } from 'mdbvue';
import { Auth0Client } from '@auth0/auth0-spa-js';
import {AUTHO_DOMAIN,AUTHO_CLIENTID,AUTHO_REDIRECT_URI} from '@/constants/general_constants';
import { AsgardeoSPAClient } from "@asgardeo/auth-spa";
import {LOCAL_HOST,WSO_CLIENTID,WSO_BASEURL} from '@/constants/general_constants';

const auth0 = new Auth0Client({
  domain: AUTHO_DOMAIN,
  clientId: AUTHO_CLIENTID,
  authorizationParams: {
    redirect_uri: AUTHO_REDIRECT_URI
  }
});

const auth = AsgardeoSPAClient.getInstance();
auth.initialize({
     signInRedirectURL: LOCAL_HOST+"/ssowsocallback",
     signOutRedirectURL: LOCAL_HOST+"/ssowsologout",
     clientID: WSO_CLIENTID,
     baseUrl: WSO_BASEURL,
     scope: [ "profile" ]
});

export default {
    name: 'Body',
    data(){
        return{user:'', encrypt_flag:0,screen_height:'auto', LOCAL_HOST:this.$store.state.LOCAL_HOST,
        pass:'',message:'',err:'',layoutData:[], layout_ready:false,sso_button:"Login with Company Account" }
    },
    components:{
        mdbContainer,
        mdbRow,
        mdbCol,mdbInput, mdbBtn,mdbCard, mdbCardBody, mdbBadge 
    },
    created (){
        this.getLayout();
        document.documentElement.setAttribute("lang", "en");
        Weglot.switchTo('en');
        document.title="Login";
    },
    updated(){
        if(this.layoutData.IS_AUTHO_SSO==1){
            document.getElementById('loginAuthO').addEventListener('click', async () => {
                await auth0.loginWithRedirect();
            });
        } else if(this.layoutData.IS_WSO_SSO==1){
            document.getElementById('loginWSO').addEventListener('click', async () => {
                //console.log('clicked');
                var login_hint = this.$route.query.login_hint;
                if(!login_hint){
                    login_hint = '';
                }
                //console.log('login_hint',login_hint);
                await auth.signIn({login_hint: login_hint});
                this.$router.push({path:'/ssowsocallback'});
            });
        }
    },    
    methods:{
        sso_url:function(){
            var queryParam;
            var login_hint = this.$route.query.login_hint;
            if(login_hint == '' || login_hint === undefined){
                queryParam = '';
            } else {
                queryParam = '&login_hint='+login_hint;
            }
            axios.post(this.$store.state.apiUrl+'/sso_url')
            .then(response => {
                //console.log(response.data);
                window.location.href = response.data.authUrl+queryParam;
            })
            .catch(() => {
                this.err='Unable to get SSO Login URL'
            });
        },
        async getLayout(){
            localStorage.clear();
            localStorage.encrypt_flag = this.encrypt_flag;
            localStorage.id_eap = this.$route.params.company_id;
            localStorage.filename = this.$route.params.file_name;
            const config = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }
            const formData = new FormData()
            formData.append('id_eap', this.$route.params.company_id)
            formData.append('filename', this.$route.params.file_name)            
           
            await axios.post(this.$store.state.apiUrl+'/login_page',formData,config)
            .then(response => {
                response = response.data
               /* if(response === undefined || response.length == 0 ){
                    //console.log('invalid')
                    this.err='! Invalid Credential / No Access'
                }
                else{*/
                //console.log('ttt-'+response.COMPANYANNOUNCEMENTLABEL)
                    var login_hint = this.$route.query.login_hint;
                    this.layoutData=response;
                    this.$store.state.companyData['custom_login'] = response
                    this.pass=response.COMPANYPASSWORD
                    this.user=response.COMPANYUSERNAME
                    if(response.SSO_BUTTON_LABEL!==undefined && response.SSO_BUTTON_LABEL!=""){
                        this.sso_button=response.SSO_BUTTON_LABEL;
                    }
                    if(response.COMPANYPASSWORD){
                        this.encrypt_flag=1
                    }
                    this.screen_height=window.innerHeight+'px'                    
                    if(response.CUSTOMREDIRECT==undefined){
                        sessionStorage.setItem('intended_url','');
                    }else{
                        sessionStorage.setItem('intended_url',response.CUSTOMREDIRECT);
                    }
                    if(this.layoutData.ENABLE_SSO==1 && this.layoutData.SSO_PASSTHROUGH==1){
                        if(this.layoutData.IS_AZURE_SSO==1){
                            this.sso_url();
                        } else if(this.layoutData.IS_WSO_SSO==1){
                            if(!login_hint){
                                login_hint = '';
                            }
                            this.wsoSSO(login_hint);
                            
                        } else if(this.layoutData.IS_AUTHO_SSO==1){
                            auth0.loginWithRedirect();
                        }
                    } else if(this.layoutData.ENABLE_SSO==1 && login_hint){
                        if(this.layoutData.IS_WSO_SSO==1){
                            this.wsoSSO(login_hint);
                        }
                    }else{
                        this.layout_ready=true;
                    }

                    if(sessionStorage.getItem("login_err_display") !== undefined && sessionStorage.getItem("login_err_display") != '' && sessionStorage.getItem("login_err_display") != null ){
                        this.err=sessionStorage.getItem("login_err_display");
                        sessionStorage.removeItem("login_err_display");
                    }
                    
                    //sessionStorage.setItem('intended_url','/content/101103');
                    //console.log('tttuyuyu-'+this.layoutData.COMPANYANNOUNCEMENTLABEL)
                   
                //}
                
            })
            .catch(() => {
                this.layoutData = [];
                this.layout_ready=false;
                this.err='Try after sometime'
            });
            //event.preventDefault();
        

        },

        async wsoSSO(login_hint){
            await auth.signIn({login_hint: login_hint});
            this.$router.push({path:'/ssowsocallback'});
        },
        
        validateLogin:function(){
            
           //alert('in mdb login');
           this.err="";
            if(this.user==''){
                this.err='Enter the Company code'
                this.$refs.ccode.focus();
                return false;
            }
            if(this.pass==''){
                this.err='Enter the Password'
                this.$refs.psw.focus();
                return false;
            }
            const config = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }
            const formData = new FormData()
            formData.append('username', this.user)
            formData.append('password', this.pass)
            formData.append('encrypt_flag', this.encrypt_flag)
            formData.append('id_eap', this.$route.params.company_id)
            formData.append('filename', this.$route.params.file_name)
            formData.append('origref', document.referrer)
        
            axios.post(this.$store.state.apiUrl+'/login',formData,config)
            .then(response => {
                var messageer= response.data;
                response = response.data[0]
                if(response === undefined || response.length == 0 ){
                    if(this.layoutData['SECONDLOGINPAGE']==1){
                        this.$store.state.companyData['custom_login']['COMPANYPASSWORD']=this.user;
                        this.$router.push({path:'/CompanyChooser/'+this.$route.params.company_id+'/'+this.$route.params.file_name})     
                        return false;               
                    } else {
                        if(messageer.message){
                            this.err=messageer.message;
                        }
                        else{
                            this.err='! Invalid Credential or No Access'
                        }
                        this.user = '';
                        if(!this.encrypt_flag){
                            this.pass= '';
                        }                        
                        this.$refs.ccode.focus();
                    }
                }
                else{
                    this.$store.state.companyData=response
                    this.$store.state.companyData['custom_text_1'] = response.custom_text_1
                    this.$store.state.companyData['custom_text_2'] = response.custom_text_2
                    this.$store.state.companyData['custom_text_3'] = response.custom_text_3
                    this.$store.state.companyData['custom_text_4'] = response.custom_text_4
                    this.$store.state.companyData['custom_text_5'] = response.custom_text_5
                    this.$store.state.companyData['id_company'] = response.id_company
                    this.$store.state.companyData['encrypt_key'] = response.encrypt_key
                    
                    this.$store.state.companyData['id_design'] = response.id_design
                    this.$store.state.companyData['id_eap'] = response.id_eap
                    this.$store.state.companyData['filename'] = response.filename
                    this.$store.state.companyData['id_service'] = response.id_service
                    this.$store.state.companyData['name_company'] = response.name_company
                    this.$store.state.companyData['name_css'] = response.name_css
                    this.$store.state.companyData['id_language'] = response.language_id_default.substr(3,3)
                    this.$store.state.companyData['id_country'] = response.language_id_default.substr(0,3)
                    this.$store.state.companyData['id_session'] = response.id_session
                    this.$store.state.companyData['login_user'] = response.logname 
                    this.$store.state.companyDataInfo.company_logo=response.company_logo
                    localStorage.company_logo=response.company_logo 
                    localStorage.id_company = response.id_company;
                    localStorage.id_design = response.id_design;
                    localStorage.id_eap = response.id_eap;
                    localStorage.id_service = response.id_service;
                    localStorage.id_service_link = response.id_service_link;
                    localStorage.id_language = response.language_id_default.substr(3,3);
                    localStorage.id_country = response.language_id_default.substr(0,3);
                    localStorage.custom_text_1 = response.custom_text_1;
                    localStorage.encrypt_key = response.encrypt_key;
                    localStorage.name_company = response.name_company;
                    localStorage.custom_text_2 = response.custom_text_2;
                    localStorage.custom_text_3 = response.custom_text_3;
                    localStorage.custom_text_4 = response.custom_text_4;
                    localStorage.custom_text_5 = response.custom_text_5;
                    localStorage.filename = response.filename;
                    localStorage.id_session = response.id_session;
                    localStorage.login_user = response.logname;
                    //console.log('w-',this.$store.state.companyData )
                    if(response.language_id_default==""){                     
                    this.$router.push({path:'/languageChooser'})     
                    return false                 
                    }
                    //api_private_key=this.$store.state.generate_privatekey('geme')
                    this.$store.dispatch('getTheme');
                    this.$store.dispatch('getLanguageTerms');
                    this.$store.dispatch('getThemeLogic');
                    this.$store.dispatch('getCompanyDataInfo');
                    if( sessionStorage.getItem('intended_url') != '' && sessionStorage.getItem('intended_url') != null)
                    {
                        let intended_url = sessionStorage.getItem('intended_url');
                        sessionStorage.removeItem('intended_url');
                        this.$router.push({path:intended_url});
                    }
                    else
                    {
                        sessionStorage.removeItem('intended_url');
                        this.$router.push({path:'/'})
                    }
                }
                
            })
            .catch(() => {
                this.company_data = [];
                this.err='Try after sometime'
            });
            event.preventDefault();
        }
    }
 
};
</script>
<style scoped>
.login-box{
    margin-top: 15px;    
    padding: 10px;
    background-color: #ffffffd1;
    margin-bottom: 50px;
}
.badge{
    font-size: 85%;
    white-space: inherit;
    padding: 7px;
}
.col-md-4{
    padding-left: 2px;
}
.btn-login{
    background-color: #245d89 !important;    
    color: #fff !important;
}
.btn-login:focus {
    background-color: #186860 !important;
    outline: 2px dotted #e9f8ff !important;
    border: 2px dotted #1d1d1d !important;
    outline-offset: -1px !important;
}
.text-center span{
    color: #D3350D !important;
}
.bg-cover{
    background-size: cover !important; 
    background-position: center center !important;
    background-repeat: no-repeat !important;
}
.text-center-align{
    text-align: center !important;
}

.justify-content-md-center {
    -ms-flex-pack: center!important;
    -webkit-box-pack: center!important;
    justify-content: center!important;
}
@media screen and (max-width: 767px) {
    .custom_login_outer{
        min-width: 85%;
    }
    .logo-img{
        width:auto !important;
        height: 30px;
    }
}
.btn-sso{
    background-color: #ffffff !important;
    color: #2d2b2b !important;
    -webkit-box-shadow: 0 2px 5px 0 rgb(0 0 0 / 1%), 0 2px 10px 0 rgb(0 0 0 / 12%);
    box-shadow: 0 2px 5px 0 rgb(0 0 0 / 1%), 0 2px 10px 0 rgb(0 0 0 / 12%);
    padding: 9px 10px;
    text-transform: none;
}
.btn-sso:hover{
    box-shadow: 0 5px 11px 0 rgb(0 0 0 / 18%), 0 4px 15px 0 rgb(0 0 0 / 15%);
    
}
.btn-sso:focus{
    color:#FFF !important;
}
.orsection{
     border-top: 1px solid #cfceceab; text-align: center; position: relative;
     margin-top: 22px;
}
.orspan{
    position: relative; top: -.8em; background: white; display: inline-block;
    color: #9f9f9fd1 !important;
}
</style>
